module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImZiIj4KPGcgaWQ9IlZlY3RvciAyOTk4Ij4KPHBhdGggZD0iTTEyIDBIOUM2LjIzODU4IDAgNCAyLjIzODU4IDQgNVY3SDBWMTFINFYxOEg4VjExSDEyVjdIOFY1QzggNC40NDc3MiA4LjQ0NzcxIDQgOSA0SDEyVjBaIiBmaWxsPSIjRUIyMTI3Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/ic_fb.svg
// module id = xUL2
// module chunks = 1